import { render, staticRenderFns } from "./langType.vue?vue&type=template&id=cd4b308a&scoped=true"
import script from "./langType.vue?vue&type=script&lang=js"
export * from "./langType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4b308a",
  null
  
)

export default component.exports